import React, { Children, PureComponent } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Icon from '@duel/icon';
import BrandFlag from './BrandFlag';
import PrimaryNavigation from './PrimaryNavigation';
import SecondaryNavigation from './SecondaryNavigation';
import UtilityNavigation from './UtilityNavigation';
import styles from './NavigationBar.scss';

export default class NavigationBar extends PureComponent {
	static propTypes = {
		brandHref: PropTypes.string.isRequired,
		brandImage: PropTypes.string,
		children: PropTypes.node.isRequired,
		maxWidth: PropTypes.string,
		onBrandClick: PropTypes.func
	};

	constructor(props) {
		super(props);
		this.state = { expanded: false };
	}

	render() {
		const { brandHref, brandImage, onBrandClick, maxWidth } = this.props;
		const { expanded } = this.state;

		const children = Children.toArray(this.props.children);
		const primaryNavigation = children.find(
			child => child.type === PrimaryNavigation
		);
		const secondaryNavigation = children.find(
			child => child.type === SecondaryNavigation
		);
		const utilityNavigation = children.find(
			child => child.type === UtilityNavigation
		);

		return (
			<header className={cx('c-navigation-bar', expanded && styles.expanded)}>
				<div
					className={cx(
						styles.brandFlagContainer,
						utilityNavigation && styles.hasUtility
					)}
					style={{ maxWidth }}>
					<BrandFlag {...{ brandHref, brandImage, onClick: onBrandClick }} />
				</div>
				<div className={styles.expand}>
					<div className={styles.menuButton} onClick={this.handleMenuClick}>
						{expanded ? (
							<Icon className={styles.menuCloseIcon} type="clear" />
						) : (
							'Menu'
						)}
					</div>
				</div>
				<div className={styles.navigation}>
					<div className={styles.main}>
						<div className={styles.content} style={{ maxWidth }}>
							{primaryNavigation}
							{secondaryNavigation}
						</div>
					</div>
					{utilityNavigation && (
						<div className={styles.utility}>
							<div className={styles.content} style={{ maxWidth }}>
								{utilityNavigation}
							</div>
						</div>
					)}
				</div>
			</header>
		);
	}

	handleMenuClick = () => {
		this.setState(state => ({ expanded: !state.expanded }));
	};
}
